import moment from 'moment'
const SocketModule = {
  namespaced: true,
  state: () => ({
    socketConnected: false,
    deviceName: '',
    isCardInserted: false,
    isDeviceActivated: false,
    readData: null,
    errorConnect: null,
  }),
  getters: {
    getSocketConnected: state => state.socketConnected,
    getDeviceName: state => state.deviceName,
    getIsCardInserted: state => state.isCardInserted,
    getIsDeviceActivated: state => state.isDeviceActivated,
    getReadData: state => state.readData
  },
  mutations: {
    setSocketConnected: (state, payload = false) => {
      state.socketConnected = payload.socketConnected;
    },
    setEventData: (state, payload) => {
      state.deviceName = payload ? payload.deviceName : '';
      state.isCardInserted = payload ? payload.isCardInserted : false;
      state.isDeviceActivated = payload ? payload.isDeviceActivated : false;
      state.readData = payload ? payload.readData : null;
      if (state.readData && state.readData.success && state.readData.data) {
        let dataSplit = splitAddress(state.readData.data.address)
        let expireDate = state.readData.data.expireDate
        let dateOfBirth = state.readData.data.dateOfBirth
        let issueDate = state.readData.data.issueDate
        let fullNameTH = state.readData.data.fullNameTH
        let fullNameEN = state.readData.data.fullNameEN
        let momentExpireDate = moment(`${expireDate.day}/${expireDate.month}/${expireDate.year}`, 'DD/MM/YYYY')
        let momentDateOfBirth = moment(`${dateOfBirth.day}/${dateOfBirth.month}/${dateOfBirth.year}`, 'DD/MM/YYYY')
        let momentIssueDate = moment(`${issueDate.day}/${issueDate.month}/${issueDate.year}`, 'DD/MM/YYYY')
        if (issueDate) issueDate.format = momentIssueDate.format('DD MMM YYYY')
        if (dateOfBirth) dateOfBirth.format = momentDateOfBirth.format('DD MMM YYYY')
        if (expireDate) expireDate.format = momentExpireDate.format('DD MMM YYYY')
        if (fullNameTH)  fullNameTH.fullName = `${fullNameTH.title} ${fullNameTH.firstName}${fullNameTH.middleName ? ' ' + fullNameTH.middleName : ''} ${fullNameTH.lastName}`
        if (fullNameEN)  fullNameEN.fullName = `${fullNameEN.title} ${fullNameEN.firstName}${fullNameEN.middleName ? ' ' + fullNameEN.middleName : ''} ${fullNameEN.lastName}`
        state.readData.data = { ...state.readData.data, ...dataSplit, momentExpireDate, momentDateOfBirth, momentIssueDate }
        if (state.readData.data.fullNameTH.title == 'น.ส.') state.readData.data.fullNameTH.title = 'นางสาว'
      }
    },
    setErrorConnect: (state, payload = false) => {
      state.errorConnect = payload.errorConnect;
    }
  }
}

const splitAddress = (address) => {
  let res = {
    firstAddress: '',
    subDistrict: '',
    district: '',
    province: '',
    postcode: '',
  }
  if (address) {
    let arrAddress = address.split(' ')
    let indexSubDsitrict = arrAddress.findIndex(t => (t).substring(0, 4) == 'แขวง' || (t).substring(0, 4) == 'ตำบล')
    let subDistrict = arrAddress.find(t => (t).substring(0, 4) == 'แขวง' || (t).substring(0, 4) == 'ตำบล') || ''
    let district = arrAddress.find(t => (t).substring(0, 3) == 'เขต' || (t).substring(0, 5) == 'อำเภอ') || ''
    let province = arrAddress.find(t => (t).substring(0, 7) == 'จังหวัด') || ''
    for (let index = 0; index < indexSubDsitrict; index++) {
      res.firstAddress += `${index > 0 ? ' ' : ''}${arrAddress[index]}`
    }
    res.subDistrict = subDistrict ? subDistrict.replace('แขวง', '').replace('ตำบล', '') : ''
    res.district = district ? district.replace('เขต', '').replace('อำเภอ', '') : ''
    res.province = province ? province.replace('จังหวัด', '') : ''
  }
  return res
}

export default SocketModule;
